"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBixConversionApplicationLink = void 0;
const crypto_1 = __importDefault(require("crypto"));
const querystring_1 = __importDefault(require("querystring"));
const aes_256_cbc_key_iv_json_1 = require("./aes-256-cbc-key-iv.json");
function createBixConversionApplicationLink(policyId) {
    const cipher = crypto_1.default.createCipheriv('aes-256-cbc', Buffer.from(aes_256_cbc_key_iv_json_1.key, 'hex'), Buffer.from(aes_256_cbc_key_iv_json_1.iv, 'hex'));
    const encryptedPolicyId = cipher.update(policyId, 'utf8', 'hex') + cipher.final('hex');
    const querystring = querystring_1.default.stringify({ policyId: encryptedPolicyId });
    return `https://ourbranch.com/convert?${querystring}`;
}
exports.createBixConversionApplicationLink = createBixConversionApplicationLink;
//# sourceMappingURL=index.js.map